export const fCityStateSplitter = (sLocation, aStateList) => {
  const sCity = sLocation.split(', ')[0];
  const oResult = {
    city: sCity,
  };
  const sStateAbbrv = sLocation.slice(-3, -1);
  const oState = aStateList.find(
    (item) => item.DETAILS.STATE_ABBRV === sStateAbbrv
  );
  if (oState) {
    oResult.state = {
      ID: oState.ID,
      DESCRIPTION: oState.DESCRIPTION,
    };
  }
  return oResult;
};

export const oEmptyAdvancedSearch = {
  firstname: '',
  lastname: '',
  city: '',
  state: { ID: null, DESCRIPTION: '' },
  country: { ID: null, DESCRIPTION: '' },
  classof: '',
  employer: { NAME: '', LOOKUPID: '' },
  educationalprogram: { ID: null, DESCRIPTION: '' },
  educationalinvolvement: { ID: null, DESCRIPTION: '' },
  educationaldepartment: { ID: null, DESCRIPTION: '' },
  affinitygroup: { ID: null, DESCRIPTION: '' },
  industry: { ID: null, DESCRIPTION: '' },
};
